module.exports = __webpack_public_path__ + "media/packs/images/flags/CD-e9ed9f0c6d7a88715543654d2d6cee30.png";